/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ key: NonNullable<unknown> }} Lifecycle_Delete_Type_KeyInputs */

const en_lifecycle_delete_type_key = /** @type {(inputs: Lifecycle_Delete_Type_KeyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Type ${i?.key} to confirm`)
};

const de_lifecycle_delete_type_key = /** @type {(inputs: Lifecycle_Delete_Type_KeyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gib ${i?.key} zur Bestätigung ein`)
};

/**
* | output |
* | --- |
* | "Type {key} to confirm" |
*
* @param {Lifecycle_Delete_Type_KeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_delete_type_key = /** @type {((inputs: Lifecycle_Delete_Type_KeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Delete_Type_KeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_delete_type_key(inputs)
	return en_lifecycle_delete_type_key(inputs)
});